import { render, staticRenderFns } from "./StockProduction.vue?vue&type=template&id=4e74f128&scoped=true&"
import script from "./StockProduction.vue?vue&type=script&lang=js&"
export * from "./StockProduction.vue?vue&type=script&lang=js&"
import style0 from "./StockProduction.vue?vue&type=style&index=0&id=4e74f128&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e74f128",
  null
  
)

export default component.exports